'use client';

import { Product } from "@/payload-types";
import useEmblaCarousel from "embla-carousel-react";
import ProductCard from "@/components/ProductCard";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useContext } from "react";
import { ThemeContext } from "@/providers/ThemeContext";
import { clsx } from "clsx";

interface IProductCarouselProps {
  products?: Product[];
  label?: string
}

export default function ProductCarousel(props: IProductCarouselProps) {
  const { label, products } = props;

  const [emblaRef, emblaApi] = useEmblaCarousel({loop: true, align: 'start'});

  const theme = useContext(ThemeContext);

  if (!products?.length) return null;

  return (
    <div className='mt-6 md:mt-12'>
      <div className="flex items-center justify-between gap-6">
        {label && <h2 className='text-h5-mobile md:text-h5'>{label}</h2>}
        <div className="flex gap-4 md:gap-5">
          <button
            className="p-1 md:p-2 text-secondary bg-background border-2 border-secondary rounded-xl hover:bg-gray-100 cursor-pointer"
            onClick={() => emblaApi?.scrollPrev()}
          >
            <ChevronLeft width={20} height={20} />
          </button>
          <button
            className="p-1 md:p-2 text-secondary bg-background border-2 border-secondary rounded-xl hover:bg-gray-100 cursor-pointer"
            onClick={() => emblaApi?.scrollNext()}
          >
            <ChevronRight width={20} height={20} />
          </button>
        </div>
      </div>
      <div className='relative overflow-hidden py-2 mt-2' ref={emblaRef}>
        <div className='flex -mr-6 will-change-transform'>
          {products.map((product) => (
            <div
              key={product.id}
              className='min-w-0 flex-carousel-2 md:flex-carousel-3 lg:flex-carousel-4 pr-6'
            >
              <ProductCard product={product} theme={theme} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
